import { useEffect, useState } from 'react';
import { getCommonInfo, getPAJAJ010, putPAJAJ010 } from '../../../services/Api';
import SideNav from '../../../shared/components/SideNav';
import { handleFocus } from '../../../utils';

const PAJAJ010 = () => {
    const [authPass, setAuthPass] = useState('');
    const [confirmPass, setConfirmPass] = useState('');
    const [useYN, setUseYN] = useState('');
    const [checkSecondPassSet, setCheckSecondPassSet] = useState('');
    const [plainPassword, setPlainPassword] = useState('');

    useEffect(() => {
        setPlainPassword('');
    }, [useYN]);

    useEffect(() => {
        getCommonInfo()
            .then(({ data }) => {
                setCheckSecondPassSet(data.checkSecondPassSet);
                setUseYN(data.checkSecondPassSet);
            })
            .catch((error) => console.log(error));
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'authPass') setAuthPass(value);
        else if (name === 'confirmPass') setConfirmPass(value);
        else if (name === 'useYN') setUseYN(value);
        else if (name === 'plainPassword') setPlainPassword(value);
    };

    const handleSave = async () => {
        const passwordRegex = /^.{4,12}$/;

        if (checkSecondPassSet === 'Y') {
            if (plainPassword === '') {
                window.alert('등록된 조회권한 비밀번호와 입력하신 현재 비밀번호가 일치하지 않습니다.');
                handleFocus('plainPassword');
                return;
            }

            try {
                const response = await getPAJAJ010({ params: { authPass: plainPassword } });
                if (response?.data === 'mismatched') {
                    window.alert('등록된 조회권한 비밀번호와 입력하신 현재 비밀번호가 일치하지 않습니다.');
                    handleFocus('plainPassword');
                    return;
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (useYN === 'Y') {
            if (authPass === '') {
                window.alert('비밀번호를 입력해 주세요.');
                handleFocus('authPass');
                return;
            }

            if (!passwordRegex.test(authPass)) {
                window.alert('비밀번호 4~12자리의 영문, 숫자, 특수문자 혼합 가능');
                handleFocus('authPass');
                return;
            }

            //
            if (authPass !== confirmPass) {
                window.alert('입력하신 비밀번호와 비밀번호확인이 일치하지 않습니다.');
                handleFocus('confirmPass');
                return;
            }
        }

        const payload = {
            authPass,
            useYN,
        };

        putPAJAJ010(payload)
            .then(() => {
                window.alert('변경되었습니다.');
                setAuthPass('');
                setConfirmPass('');
                sessionStorage.removeItem('authPassVerified');
                localStorage.removeItem('savedPAEAA010Conditions');
                localStorage.removeItem('savedPAFAA010Conditions');
                window.location.reload();
            })
            .catch((error) => console.log(error));
    };
    return (
        <div id="content" className="sub-page PAJAJ010">
            <div className="container">
                <div id="top-sub-page">
                    <SideNav />
                    <div className="resume">
                        <div className="resume__inner">
                            <h3 className="resume__tit">내 정보 잠금 설정</h3>
                            <div className="mdf">
                                <div className="mdf__container2">
                                    <div className="mdf__notice2">
                                        <i>※</i>
                                        <span>마이 페이지 사용에 대한 2차 비밀번호을 설정할 수 있습니다.</span>
                                    </div>
                                    <div className="mdf__notice2">
                                        <i>※</i>
                                        <span>
                                            마이 페이지 2차 비밀번호를 설정함으로 선택하신 경우에는 2차 비밀번호를
                                            입력하셔야 상세내용을 볼 수 있습니다.
                                        </span>
                                    </div>
                                    <div className="mdf__notice2">
                                        <i>※</i>
                                        <span>
                                            추가적인 보안조치가 필요한 경우 2차 비밀번호을 설정하시고 이용하시기
                                            바랍니다.
                                        </span>
                                    </div>
                                    <div className="mdf__notice2">
                                        <i>※</i>
                                        <span>
                                            2차 비밀번호을 설정함 → 설정안함으로 변경 후 다시 설정하는 경우 다시 2차
                                            비밀번호를 등록하셔야 합니다.
                                        </span>
                                    </div>
                                </div>
                                <div className="lck__tit">
                                    <div className="lck__icon" />
                                    2차 비밀번호 설정
                                </div>
                                <div className="lck__set">
                                    <label className="lck__label" htmlFor="useN">
                                        · 마이 페이지 2차 비밀번호 설정 안함
                                    </label>
                                    <input
                                        type="radio"
                                        name="useYN"
                                        id="useN"
                                        value="N"
                                        checked={useYN === 'N'}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="lck__set">
                                    <label className="lck__label" htmlFor="useY">
                                        · 마이 페이지 2차 비밀번호 설정함
                                    </label>
                                    <input
                                        type="radio"
                                        name="useYN"
                                        id="useY"
                                        value="Y"
                                        checked={useYN === 'Y'}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="lck__tit mt40">
                                    <div className="lck__icon" />
                                    마이 페이지 2차 비밀번호를 설정함으로 선택한 경우 입력하세요. (덴탈잡, 공통 적용)
                                </div>

                                {((checkSecondPassSet === 'Y' && useYN === 'N') ||
                                    (checkSecondPassSet === 'Y' && useYN === 'Y')) && (
                                        <div className="lck__set2">
                                            <label className="lck__label2" htmlFor="plainPassword">
                                                · 현재 조회권한 비밀번호
                                            </label>
                                            <div className="lck__flex">
                                                <input
                                                    id="plainPassword"
                                                    type="password"
                                                    className="lck__pswd"
                                                    name="plainPassword"
                                                    value={plainPassword}
                                                    onChange={handleInputChange}
                                                    autoComplete="new-password"
                                                />
                                            </div>
                                        </div>
                                    )}

                                <div className="lck__set2">
                                    <label className="lck__label2" htmlFor="authPass">
                                        · 변경할 2차 비밀번호
                                    </label>
                                    <div className="lck__flex">
                                        <input
                                            id="authPass"
                                            type="password"
                                            className="lck__pswd"
                                            name="authPass"
                                            disabled={
                                                (checkSecondPassSet === 'N' && useYN === 'N') ||
                                                (checkSecondPassSet === 'Y' && useYN === 'N')
                                            }
                                            onChange={handleInputChange}
                                            autoComplete="new-password"
                                            maxLength={12}
                                        />
                                        <span style={{ letterSpacing: '-0.2px', lineHeight: '1.2' }}>
                                            4~12자리(*비밀번호 최초등록 또는 기존 비밀번호<br></br>변경시 입력하세요.)
                                        </span>
                                    </div>
                                </div>
                                <div className="lck__set2">
                                    <label className="lck__label2" htmlFor="confirmPass">
                                        · 변경할 2차 비밀번호 확인
                                    </label>
                                    <div className="lck__flex">
                                        <input
                                            id="confirmPass"
                                            type="password"
                                            className="lck__pswd"
                                            name="confirmPass"
                                            onChange={handleInputChange}
                                            disabled={
                                                (checkSecondPassSet === 'N' && useYN === 'N') ||
                                                (checkSecondPassSet === 'Y' && useYN === 'N')
                                            }
                                            maxLength={12}
                                            autoComplete="new-password"
                                        />
                                        <span>입력하신 변경할를 한번 더 입력해 주세요.</span>
                                    </div>
                                </div>
                            </div>
                            <div className="mdf__btbx">
                                <button type="button" className="mdf__btn mdf__btn--blue" onClick={handleSave}>
                                    수정
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAJAJ010;
